import { css } from "@emotion/react";
import React, { memo } from "react";

/**
 * Full-bleed media treatment — edge-to-edge photo (legacy l3 / Fullscreen
 * image slot). Design theme does not style this image; layout CSS only.
 */
const styles = {
  image: css`
    display: block;
    width: 100%;
  `,
  photoContainer: css`
    position: relative;
  `,
  // Legacy fancyclothes overlay hook; kept for parity with HorizontalFullHeader.
  shadow: css`
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  `,
};

export type FullBleedMediaProps = {
  alt: string;
  headerSlotPosition: number;
  photoURL: string;
};

const FullBleedMedia = ({
  alt,
  headerSlotPosition,
  photoURL,
}: FullBleedMediaProps) => (
  <div css={styles.photoContainer}>
    <div css={styles.shadow} />
    <img
      alt={alt}
      css={styles.image}
      data-cy="mainImage"
      data-slot-index={headerSlotPosition}
      src={photoURL}
    />
  </div>
);

const MemoizedFullBleedMedia = memo(FullBleedMedia);

export { MemoizedFullBleedMedia as FullBleedMedia };
